import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const EyeOff = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M9.165 4.42a.75.75 0 0 0 .433 1.437zm12.364 6.698.652-.372zm-2.388 3.849a.75.75 0 0 0 1.127.99zm2.389-2.086-.652-.371zM3.28 2.22a.75.75 0 0 0-1.06 1.06zm-.81 8.899.652.371zM20.72 21.78a.75.75 0 1 0 1.06-1.06zM2.47 12.883l-.651.371zm7.761-2.65a.75.75 0 1 0-1.06-1.061zm4.597 4.595a.75.75 0 1 0-1.061-1.06zm-5.231-8.97c3.941-1.187 8.396.572 11.28 5.631l1.303-.743C19.03 5.217 13.918 2.99 9.165 4.421zm10.67 10.1a16.3 16.3 0 0 0 1.913-2.706l-1.303-.742c-.53.93-1.113 1.748-1.737 2.457zm.61-4.469c.18.317.18.705 0 1.02l1.303.743a2.53 2.53 0 0 0 0-2.506zM2.22 3.28 6 7.06 7.06 6 3.28 2.22zm.902 8.21c1.092-1.916 2.412-3.357 3.835-4.344l-.854-1.233c-1.63 1.13-3.095 2.748-4.284 4.835zm2.877-4.43L16.94 18 18 16.94 7.06 6zM16.94 18l3.78 3.78 1.06-1.06L18 16.94zM1.82 13.255c1.928 3.383 4.586 5.535 7.475 6.363 2.897.83 5.953.306 8.603-1.53l-.855-1.233c-2.3 1.594-4.893 2.02-7.334 1.321-2.448-.7-4.815-2.557-6.586-5.664zm-.001-2.506a2.53 2.53 0 0 0 0 2.506l1.304-.742a1.03 1.03 0 0 1-.001-1.022zM12 14.5A2.5 2.5 0 0 1 9.5 12H8a4 4 0 0 0 4 4zM9.5 12c0-.69.28-1.315.732-1.768l-1.06-1.06A4 4 0 0 0 8 12zm4.268 1.768A2.5 2.5 0 0 1 12 14.5V16a4 4 0 0 0 2.829-1.172z'
        fill='currentColor'
      />
    ) : (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.28 2.22a.75.75 0 0 0-1.06 1.06l3.167 3.168c-1.344 1.085-2.557 2.522-3.57 4.3a2.53 2.53 0 0 0 .002 2.506c1.928 3.382 4.586 5.535 7.475 6.363 2.707.775 5.553.369 8.076-1.186l3.35 3.35a.75.75 0 1 0 1.06-1.061zm10.968 13.088-1.092-1.091a2.5 2.5 0 0 1-3.374-3.374L8.69 9.75a4 4 0 0 0 5.557 5.557'
          fill='currentColor'
        />
        <path
          d='M19.723 16.542a16 16 0 0 0 2.458-3.29 2.53 2.53 0 0 0 0-2.504C19.658 6.319 15.88 4 12 4a9.95 9.95 0 0 0-3.979.84z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
